import _IconWarning from "@arco-design/iconbox-react-m4b-next/esm/IconWarning";
import _IconError from "@arco-design/iconbox-react-m4b-next/esm/IconError";
import _IconSuccess from "@arco-design/iconbox-react-m4b-next/esm/IconSuccess";
import _IconInfoNeutral from "@arco-design/iconbox-react-m4b-next/esm/IconInfoNeutral";
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React, { useContext } from 'react';
import { Message as ArcoMessage } from '@arco-design/web-react';
import { IconContext } from '@arco-design/web-react/icon/react-icon/context';
import { useConfigContext, getGlobalContext } from '@m4b-design/config-provider';
import cx from 'classnames';
import './style/message.less';
var Message = function Message(props) {
  var className = props.className;
  var globalPrefixCls = useConfigContext().prefixCls;
  var prefixCls = "".concat(globalPrefixCls, "-message");
  return /*#__PURE__*/React.createElement(ArcoMessage, __assign({}, props, {
    className: cx(className, prefixCls)
  }));
};
function ArcoIconWrapper(_a) {
  var Icon = _a.Icon;
  var iconConfig = useContext(IconContext);
  return /*#__PURE__*/React.createElement(Icon, {
    prefix: iconConfig.prefixCls,
    style: {
      stroke: 'none'
    }
  });
}
var messageTypes = [{
  name: 'info',
  icon: /*#__PURE__*/React.createElement(ArcoIconWrapper, {
    Icon: _IconInfoNeutral
  })
}, {
  name: 'success',
  icon: /*#__PURE__*/React.createElement(ArcoIconWrapper, {
    Icon: _IconSuccess
  })
}, {
  name: 'error',
  icon: /*#__PURE__*/React.createElement(ArcoIconWrapper, {
    Icon: _IconError
  })
}, {
  name: 'warning',
  icon: /*#__PURE__*/React.createElement(ArcoIconWrapper, {
    Icon: _IconWarning
  })
}];
var globalPrefixCls = getGlobalContext().prefixCls;
var globalCls = "".concat(globalPrefixCls, "-message");
messageTypes.forEach(function (type) {
  Message[type.name] = function (noticeProps) {
    var props = typeof noticeProps === 'object' && noticeProps !== null ? __assign(__assign({
      icon: type.icon
    }, noticeProps), {
      className: cx(noticeProps.className, globalCls)
    }) : {
      icon: type.icon,
      content: noticeProps !== null && noticeProps !== void 0 ? noticeProps : '',
      className: globalCls
    };
    return ArcoMessage[type.name](props);
  };
});
Message.clear = ArcoMessage.clear;
Message.config = ArcoMessage.config;
Message.config({
  maxCount: 3
});
Message.useMessage = ArcoMessage.useMessage;
export default Message;